import { cn, useInterval } from "@coideo/barrani";
import { useTranslation } from "next-i18next";
import React, { useEffect, useState } from "react";

const remainingTime = (date: Date) => date.getTime() - new Date().getTime();

const Countdown = ({ expireDate, onExpire }: { expireDate: Date; onExpire: () => void }) => {
  const { t } = useTranslation();
  const [time, setTime] = useState(() => remainingTime(expireDate));

  useInterval(
    () => {
      const difference = remainingTime(expireDate);

      setTime(difference <= 0 ? 0 : difference);
    },
    time > 0 ? 1000 : null,
  );

  useEffect(() => {
    if (time <= 0) onExpire();
  }, [onExpire, time]);

  const runningOut = time < 110 * 1000;
  const date = new Date(time);
  const timeLeft =
    time <= 0 ? "00:00" : `${date.getMinutes()}:${`0${date.getSeconds()}`.slice(-2)}`;

  return (
    <>
      <span className="text-xs font-medium">{t("sale.reserveTime")}</span>
      <span className={cn("font-medium", runningOut ? "animate-pulse text-red-500" : "")}>
        {timeLeft}
      </span>
    </>
  );
};

export default Countdown;
